export const SET = 'Analysis/data/pages/SET';

export function setPages(pages) {
  return {
    type: SET,
    pages
  }
}